import { defineI18nConfig } from '#i18n'
import enUS from './locales/en-US.json'
import esES from './locales/es-ES.json'
import frFR from './locales/fr-FR.json'

export default defineI18nConfig(() => ({
    legacy: false,
    // Keep locale registration in one place while loading message bodies from JSON files.
    messages: {
        'en-US': enUS,
        'es-ES': esES,
        'fr-FR': frFR
    },
    fallbackLocale: 'en-US'
}))
